
export interface TableHeader {
  text: string | undefined;
  value: string;
  sortable?: boolean;
  width?: string;
  minWidth?: string;
  maxWidth?: string;
}

export interface TableRow {
  severity: string;
  timestamps: {
    startTimestamp: string;
    endTimestamp: string;
  }
  type?: string;
  imo?: number | string;
  duration: string;
  closeVesselEventId?: number | null;
  conditionDetails: string;
  vesselName: string;
}
export const headers: TableHeader[] = [
  {
    text: "Vessel",
    value: "vesselName",
    sortable: true,
    width: "250px",
  },
  {
    text: "Status",
    value: "severity",
    sortable: true,
    width: "110px",
  },
  {
    text: "Type",
    value: "type",
    sortable: false,
    width: "93px",
  },
  {
    text: "Timeframe",
    value: "timestamps",
    sortable: false,
    width: "214px",
  },
  {
    text: "Duration",
    value: "duration",
    sortable: false,
    width: "140px",
  },
  {
    text: "Description",
    value: "conditionDetails",
    sortable: false,
    // width: "329px",
  },
];
